import Menu   from "../Menu.js";
import global from "../global.js";
import Placeholder from "../scene/Placeholder.js";
import InputCoordinatesArea from "./InputCoordinatesArea.js";
// const log = global.log.getLogger("f_mtac.ui.MapSettingsArea");
const d3 = global.d3;

const MapSettingsArea = function() {};

global.app.bootstrap.register_module({
    name: "ui_map_settings_area_tools",
    deps: ["dom_loaded", "tools", "scene", "resources_loaded"],
    init: async () => {
        const scene = global.scene;

        global.tools.register({
            name: "background_image_settings",
            icon: "brightness_menu f_mtac-icon-xlg",
            position: "#command_map_area",
            handler: () => {
                Menu.display(["background_image_settings_area"]);
            }
        });

        global.tools.register({
            name: "grid_settings",
            icon: "grid f_mtac-icon-xlg",
            position: "#command_map_area",
            handler: () => {
                Menu.display(["grid_settings_area"]);
            }
        });

        /**
         * This button provides the possibility to switch
         * Google Map types: ROADMAP, SATELLITE and TERRAIN
         */
        global.tools.register({
            name: "map_type",
            icon: "plans",
            position: "#command_map_area",
            classes : "",
            handler: async () =>  {
                if (global.view.is_gis) {
                    global.view.switch_map_basic_layer(false);
                }
            }
        });
        global.tools.tools["map_type"].$button.hide();

        global.tools.register({
            name: "geo_nodes",
            icon: "geo_nodes_a_b f_mtac-icon-xlg",
            position: "#command_map_area",
            enable: () => {},
            disable: () => {},
            data: {
                type: null,
                placeholder: null,
                placeholders:{
                    "A": new Placeholder(scene.objects.layers.geolocation.group, "pivot_a"),
                    "B": new Placeholder(scene.objects.layers.geolocation.group, "pivot_b")
                }
            },
            draggable: {
                start: (data, tool) => {
                    var projection = global.storage.selected_context.projection;
                    if (scene.objects.layers.geolocation.ids.length > 1){
                        return;
                    }
                    let {x: ox, y: oy} = tool.get_container_position();
                    data.origin = {
                        ox: 100 * scene.root_transform.k - ox,
                        oy: 100 * scene.root_transform.k - oy
                    };
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);

                    data.type = projection.A === null ? "A" : "B";
                    data.placeholder = data.placeholders[data.type];
                    data.placeholder.init({
                        color: global.scene.map.grid.configuration.get("grid.color"),
                    });
                    data.placeholder.move_to({x, y});
                },
                drag: (data) => {
                    if (data.placeholder === null){
                        return;
                    }
                    let {x, y} = scene.transform_coordinates(d3.event, data.origin);
                    data.placeholder.move_to({x, y});
                },
                end: async (data, tool) => {
                    if (data.placeholder === null){
                        return;
                    }
                    if (tool.is_inside(data.placeholder.handle.node())) {
                        data.placeholder.end();
                        data.placeholder = null;
                        data.type = null;
                        return;
                    }
                    var EN = await InputCoordinatesArea.interact({});
                    if (EN === null) {
                        data.placeholder.end();
                        data.placeholder = null;
                        data.type = null;
                        return;
                    }
                    var {x: X, y: Y} = data.placeholder.indicator_position;
                    var {E, N} = EN;
                    global.scene.map.geonodes.update(data.type, {X, Y, E, N});
                    global.scene.map.geonodes.apply();
                    data.placeholder.end();
                    data.placeholder = null;
                    data.type = null;
                }
            }
        });
    }
});

export default new MapSettingsArea();
